const planExists = state => state.plan.verifyExists !== null && state.plan.verifyExists?.type === 1

export { planExists }
